import {connect} from 'react-redux';
import VirtualEntry from './VirtualEntry.jsx';
import {
  setSelectedAffectedVirtualEntry
} from '../captainDetail/actionTypes';

const mapStateToProps = (state, props) => {
  let selected = undefined;
  let virtualEntry = state.admin.captainDetail.affectedVirtualEntries.filter(entry => entry.virtualEntryId == props.virtualEntryId)[0];

  // Sometimes old information comes in the props parameter 
  if (virtualEntry) {
    selected = virtualEntry.selected;
  } 

  return ({ 
    ...props,
    selected: selected
  });
};

const mapDispatchToProps = dispatch => ({  
  onSelectChecked: (virtualEntryId, selected) => dispatch(setSelectedAffectedVirtualEntry(virtualEntryId, selected))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEntry);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/VirtualEntryContainer.jsx